import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Blog1 = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const calculateScrollProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight - windowHeight;
      const scrollTop = window.scrollY;
      const progress = (scrollTop / documentHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', calculateScrollProgress);
    return () => window.removeEventListener('scroll', calculateScrollProgress);
  }, []);

  return (
    <article className="blog-article">
      <div className="progress-bar-container">
        <div 
          className="progress-bar"
          style={{ width: `${scrollProgress}%` }}
        />
      </div>

      <Link to="/blogs" className="back-link">
        <span className="mr-2">←</span>
        Terug naar blogs
      </Link>

      <header className="blog-header">
        <div>
          <h1 className="text-3xl font-bold text-[#2B4055] mb-2">Agile Transformatie</h1>
          <h2 className="text-xl text-[#FF6B35] mb-4">Meer dan alleen ceremonies</h2>
          <div className="flex items-center gap-4 text-gray-600">
            <span>24 maart 2024</span>
            <span>•</span>
            <span>5 min leestijd</span>
          </div>
        </div>
      </header>

      <div className="prose">
        <p className="lead">
          Als ervaren Agile coach zie ik vaak dat organisaties vastlopen in hun Agile transformatie 
          omdat ze te veel focussen op de ceremonies en te weinig op de mindset. In deze blog deel 
          ik mijn ervaringen over hoe je een succesvolle Agile transformatie realiseert door de 
          mens centraal te stellen.
        </p>

        <h2>De valkuil van ceremonie-focus</h2>
        <p>
          Veel organisaties zien Agile als een set van regels en ceremonies die ze moeten volgen. 
          Daily stand-ups, sprint planning, retrospectives - ze voeren ze allemaal braaf uit, maar 
          missen de essentie. De echte kracht van Agile zit niet in deze rituelen, maar in de 
          mindset die erachter zit.
        </p>

        <blockquote>
          "Agile gaat niet om het volgen van processen, maar om het creëren van waarde door 
          samenwerking en aanpassingsvermogen."
        </blockquote>

        <h2>De menselijke factor</h2>
        <p>
          Een succesvolle Agile transformatie begint bij de mensen. Het gaat om vertrouwen, 
          transparantie en de bereidheid om te experimenteren en te leren van fouten. Dit 
          vereist een cultuurverandering die niet van de ene op de andere dag gerealiseerd is.
        </p>

        <h2>Praktische stappen naar succes</h2>
        <ul>
          <li>
            <strong>Begin klein:</strong> Start met één team dat open staat voor verandering
          </li>
          <li>
            <strong>Focus op waarde:</strong> Maak duidelijk waarom de verandering nodig is
          </li>
          <li>
            <strong>Investeer in mensen:</strong> Zorg voor goede coaching en training
          </li>
          <li>
            <strong>Vier successen:</strong> Maak resultaten zichtbaar en deel ze
          </li>
        </ul>

        <h2>De rol van leiderschap</h2>
        <p>
          Leiders spelen een cruciale rol in de transformatie. Ze moeten het goede voorbeeld 
          geven door transparant te zijn, vertrouwen te tonen en ruimte te geven voor 
          experimenten. Dit betekent soms ook loslaten en accepteren dat niet alles direct 
          perfect gaat.
        </p>

        <h2>Data gedreven verbeteren</h2>
        <p>
          Meet de voortgang van je transformatie, maar focus op de juiste metrics. Kijk niet 
          alleen naar velocity of het aantal afgeronde story points, maar meet ook 
          medewerkerstevredenheid, klanttevredenheid en time-to-market.
        </p>

        <h2>Conclusie</h2>
        <p>
          Een Agile transformatie is een reis, geen bestemming. Door de mens centraal te stellen 
          en te focussen op de mindset in plaats van alleen de ceremonies, creëer je een 
          duurzame verandering die echt impact heeft. Het vereist geduld, toewijding en vooral 
          het vertrouwen dat teams zelf kunnen ontdekken wat voor hen het beste werkt.
        </p>
      </div>
    </article>
  );
};

export default Blog1;